import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Team.module.css"

import Sidebar from '../Sidebar';
import NewTeamMember from './NewTeamMember';
import TableUtil from '../Utils/TableUtil';
import { MovingTextContainer, MovingDateTimeContainer, MovingAutocompleteContainer } from '../Utils/Helpers'


const Banner = ({ handleOpen }) => {
	const navigate = useNavigate();
	const [showingLabel, setShowingLabel] = useState(true)
	const [search, setSearch] = useState("")
	const [userData, setUserData] = useState({})
	const divRef = useRef(null);
	const [searchResults, setSearchResults] = useState({
		events: [],
		guestiis: [],
		teamMembers: []
	})


	useEffect(() => {
		const handleLoad = async () => {
			try {
				const userId = localStorage.getItem("_id")
				const retrieve = await axios.get(`/api/hub/get-user-data/${userId}`);
				setUserData(retrieve.data.user)
			} catch (e) {
				console.log(e)
				// localStorage.removeItem("_id")
				// localStorage.removeItem("expiry")
				// window.location = "/connect"
			}
		}

		handleLoad()
	}, []);

	const handleSearch = async (input) => {
		const userId = localStorage.getItem("_id")
		const searchTerm = input.target.value
		setSearch(searchTerm)

		if (searchTerm !== "") {
			const retrieve = await axios.get(`/api/hub/${userId}/search-all/${searchTerm}`);
			setSearchResults(retrieve.data.data)
		}
	}

	function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = days[date.getDay()];
    const dateNumber = date.getDate();
    const month = months[date.getMonth()];

    const suffix =
        dateNumber % 10 === 1 && dateNumber !== 11
            ? 'st'
            : dateNumber % 10 === 2 && dateNumber !== 12
            ? 'nd'
            : dateNumber % 10 === 3 && dateNumber !== 13
            ? 'rd'
            : 'th';

    return `${day}, ${dateNumber}${suffix} ${month}`;
	}

	function convertTo24HourTime(isoString) {
    const date = new Date(isoString);
    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

    return time;
	}

	const handleClickOutside = (event) => {
  	if (divRef.current && !divRef.current.contains(event.target)) {
  		setSearch("")

			setSearchResults({
				events: [],
				guestiis: [],
				teamMembers: []
			})
  	}
	};

	const handleClickItem = (item, searchKey) => {
		const userId = localStorage.getItem("_id")

		switch (searchKey) {
			case 'events':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/hub/${userId}`)
				break;
			case 'guestiis':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/guestiis/${userId}`)
				break;
			case 'teamMembers':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				window.location.reload()
				break;
		}

	}

	useEffect(() => {
  	document.addEventListener('mousedown', handleClickOutside);

  	return () => {
    		document.removeEventListener('mousedown', handleClickOutside);
  	};
	}, []);

	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_greeting}>
				<h3>Hi, {userData.first_name}</h3>
				<p>Welcome back to your Guestii hub!</p>
			</div>

			<div className={styles.banner_tools}>
				<div className={styles.nevent_input_container_search}>
					<div
						className={styles.movingLabelSearch}
	        	style={{
	          	top: showingLabel && !search ? "50%" : "-20px",
	          	transform: showingLabel && !search ? "translate(0, -50%)" : "",
	          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, color 0.3s ease",
	          	color: !(showingLabel && !search) && "#01000D"
	        	}}
					>
						<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
						<p className={`${styles.s1}`}>Search for anything</p>
					</div>

					<input
						type="text"
						className={styles.s1}
						onChange={(input) => handleSearch(input)}
						onFocus={() => setShowingLabel(false)}
						onBlur={() => setShowingLabel(true)}
						onClick={() => setShowingLabel(false)}
						value={search}
					/>
				</div>

				{search !== "" &&
					<>
						{Object.values(searchResults).length > 0 &&
							<div className={styles.search_outer_container} ref={divRef}>
								{Object.keys(searchResults).map((searchKey) => {
									let resultItem = searchResults[searchKey]

									return (
										<>
											{resultItem.map((item) => (
												<button className={styles.searchItem} onClick={() => handleClickItem(item, searchKey)}>
													<i className={`fa-solid fa-${searchKey === "events" ? "clipboard-check" : searchKey === "guestiis" ? "clipboard-user" : "users"} ${styles.m1}`}></i>

													{searchKey === "events"
														?
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.name}</p>
																<p className={`${styles.xs3}`}>{formatDate(item.start_date)} {convertTo24HourTime(item.start_date)} - {formatDate(item.end_date)} {convertTo24HourTime(item.end_date)}</p>
															</div>
														:
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.first_name} {item.last_name}</p>
																<p className={`${styles.xs3}`}>{item.email}</p>
															</div>
													}
													
												</button>
											))}
										</>
									)
								})}
							</div>
						}
					</>
				}

				<button className={styles.profile_btn}><i className={`fa-solid fa-user ${styles.m1}`}></i></button>
			</div>
		</div>
	)
}

const TableDisplay = ({ handleOpen, setTeamInvite, teamInvite, setTeamInviteOG, setShowUpdateInvites }) => {
	const [isLoading, setIsLoading] = useState(true)
	const [showNewTeamMember, setShowNewTeamMember] = useState(false)
	const [nodes, setNodes] = useState([])
	const [nodesOG, setNodesOG] = useState([])
	const [activeNav, setActiveNav] = useState([])
	const [isEventManager, setIsEventManager] = useState(false)

	useEffect(() => {
		const handleLoad = async () => {
			setIsLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const retrieve = await axios.get(`/api/team/get-team-members/${userId}/${expiry}`);
				const flattened = ["SuperAdmin", "Event Manager", "Promoter", "Scanner"].flatMap(key => retrieve.data.teamMembers[key] ?? []);

				setNodes(flattened)
				setNodesOG(retrieve.data.teamMembers)
				setIsEventManager(!retrieve.data.isSuperAdmin)
			} catch (e) {
				console.log(e)
				// localStorage.removeItem("_id")
				// localStorage.removeItem("expiry")
				// window.location = "/connect"
			}

			setIsLoading(false)
		}

		handleLoad()
	}, []);

	useEffect(() => {
		setIsLoading(true)

		let flattened;
		if (activeNav.length === 0) {
			flattened = ["SuperAdmin", "Event Manager", "Promoter", "Scanner"].flatMap(key => nodesOG[key] ?? []);
		} else {
			flattened = activeNav.flatMap(key => nodesOG[key] ?? []);
		}

		setNodes(flattened)

		setIsLoading(false)
	}, [activeNav.length])

	const toggleActiveNav = (nav) => {
		if (activeNav.includes(nav)) {
			setActiveNav((prev) => [...prev].filter(n => n !== nav))
		} else {
			setActiveNav((prev) => [...prev, nav])
		}
	} 

	const handleQuickInvite = (team) => {
		if (teamInvite && team._id === teamInvite._id) {
			setTeamInvite(null)
			setTeamInviteOG(null)
			setShowUpdateInvites(false)
		} else {
			setTeamInvite(team)
			setTeamInviteOG(team)
			setShowUpdateInvites(false)
		}
	}

	return (
		<div className={`${styles.table_container} table_container`}>
			<div className={styles.table_banner}>
				<p>My Team</p>

				{(!isEventManager && !isLoading) &&
					<button className={styles.widget_action_container} onClick={() => handleOpen("new")}>
						<p className={`${styles.s2} ${styles.add_new}`}>Add New</p>
						<div className={styles.widget_action}><i class={`fa-solid fa-plus ${styles.m1}`}></i></div>
					</button>
				}
			</div>

			<div className={styles.team_layout} style={{ overflowY: 'scroll' }}>
				{/* <div className={styles.team_nav}> */}
					{/* <button onClick={() => setActiveNav("SuperAdmin")} className={activeNav === "SuperAdmin" && styles.team_btn_active}><p className={styles.s2}>Account Owner</p></button> */}
					{/* <button onClick={() => setActiveNav("Event Manager")} className={activeNav === "Event Manager" && styles.team_btn_active}><p className={styles.s2}>Event Managers</p></button> */}
					{/* <button onClick={() => setActiveNav("Scanner")} className={activeNav === "Scanner" && styles.team_btn_active}><p className={styles.s2}>Scanners</p></button> */}
				{/* </div> */}

				<div className={styles.team_nav_btns}>
					<button className={`${styles.team_nav_btn} ${activeNav.includes("SuperAdmin") && styles.team_nav_btn_active}`} onClick={() => toggleActiveNav("SuperAdmin")}>
						<div className={styles.team_nav_btn_icon}>
							<i className={`fa-solid fa-user ${styles.s1}`}></i>
						</div>
						<p className={styles.xs3}>Account Owners</p>
					</button>

					<button className={`${styles.team_nav_btn} ${activeNav.includes("Event Manager") && styles.team_nav_btn_active}`} onClick={() => toggleActiveNav("Event Manager")}>
						<div className={styles.team_nav_btn_icon}>
							<i className={`fa-solid fa-calendar-days ${styles.s1}`}></i>
						</div>
						<p className={styles.xs3}>Event Managers</p>
					</button>

					<button className={`${styles.team_nav_btn} ${activeNav.includes("Promoter") && styles.team_nav_btn_active}`} onClick={() => toggleActiveNav("Promoter")}>
						<div className={styles.team_nav_btn_icon}>
							<i className={`fa-solid fa-square-envelope ${styles.s1}`}></i>
						</div>
						<p className={styles.xs3}>Promoters</p>
					</button>

					<button className={`${styles.team_nav_btn} ${activeNav.includes("Scanner") && styles.team_nav_btn_active}`} onClick={() => toggleActiveNav("Scanner")}>
						<div className={styles.team_nav_btn_icon}>
							<i className={`fa-solid fa-qrcode ${styles.s1}`}></i>
						</div>
						<p className={styles.xs3}>Scanners</p>
					</button>
				</div>


				{!isLoading
					?
						<div className={(nodes && nodes.length > 0) ? styles.team_grid : styles.team_grid_shorter} style={{ gridTemplateRows: `repeat(${Math.ceil(nodes.length / 3)}, auto)`, marginTop: 15 }}>
							{(nodes && nodes.length > 0)
								?
									<>
										{nodes.map((node, index) => {
											const icon = node.role.name === "SuperAdmin" ? "user" : node.role.name === "Event Manager" ? "calendar-days" : "qrcode"

											return (
												<button className={`${styles.team_member} ${(teamInvite && teamInvite._id === node._id) && styles.activeGuestiiInvite}`} onClick={() => handleQuickInvite(node)}>
													<div className={styles.team_banner} style={{ display: 'block' }}>
														{/* <div className={styles.team_profile}> */}
														{/* 	<i class={`fa-solid fa-${icon} ${styles.s2}`}></i> */}
														{/* </div> */}
														<div className={styles.team_names}>
															<p className={styles.s2}>{node.first_name} {node.last_name} - {node.role.name}</p>
															<p className={styles.xs3}>{node.email}</p>
														</div>
													</div>
												</button>
											)
										})}
									</>
								: <div className={styles.noResults}><p>Create your first team member to start!</p></div>
							}
						</div>
					:
						<div className={`${styles.team_grid}`} style={{ gridTemplateRows: `repeat(2, auto)` }}>
							{Array.from({ length: 8 }).map((_, index) => (
								<button className={`${styles.team_member} ${styles.team_loading} shine-animation-light`}>
									<div className={`${styles.team_banner}`}>
										<div className={styles.team_profile}>
											<i class={`fa-solid fa-user ${styles.s2}`}></i>
										</div>
										<div className={styles.team_names}>
											<p className={styles.s2}>Example Guestii</p>
											<p className={styles.xs3}>example@guestii.app</p>
										</div>
									</div>
								</button>
							))}
						</div>
				}
			</div>
		</div>
	)
}



const TeamInfoWidget = ({ setTeamInvite, teamInvite, collapseFilters, handleOpen }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [stats, setStats] = useState([])

	useEffect(() => {
		setIsLoading(true)

		if (teamInvite) {
			const { first_name, last_name, last_event, upcoming_events = [], events = [] } = teamInvite;

			const totalAttended = events.length;
			const totalUpcoming = upcoming_events.length;

			const lastEventName = last_event ? last_event.name : "-";
			const lastEventDate = last_event ? new Date(last_event.start_date).toLocaleDateString() : "";

			const nextEvent = upcoming_events[0];
			const nextEventName = nextEvent ? nextEvent.name : "-";
			const nextEventLocation = nextEvent ? nextEvent.location?.formatted_address : "";

		  	const statsMade = [
		    	{ 	label: "Attended", value: totalAttended, icon: "📅" },
		    	{ 	label: "Upcoming", value: totalUpcoming, icon: "✅" },
		    	{ 	label: "Last Event", value: lastEventName, icon: "📊" },
		    	{	label: "Next Event", value: nextEventName, icon: "✉️" },
		  	];

		  	setStats(statsMade)
		}

	  	setIsLoading(false)
  	}, [teamInvite]);


  	const handleDelete = async (teamPassed) => {
  		const confirmDelete = await window.confirm("Are you sure you want to delete this Team Member, and remove their access to all events?")
  		if (confirmDelete) {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				await axios.delete(`/api/team/delete-team/${teamPassed._id}`);
				window.location.reload()
			} catch (e) {
				console.log(e)
				// localStorage.removeItem("_id")
				// localStorage.removeItem("expiry")
				// window.location = "/connect"
			}
  		}
  	}


	return (
		<div className={`${styles.widget_container} ${collapseFilters && styles.quickInviteModule} ${teamInvite && styles.flexedModule}`}>
			{!teamInvite &&
				<div className={styles.widget_banner}>
					<p>Team Member Profile</p>
				</div>
			}

			{!isLoading &&
				<>
					{teamInvite
						?
							<div className={styles.outerGuestiiInfo}>
								<div className={styles.profileBannerMain}>
									<div className={styles.guestii_profile}>
										<i class={`fa-solid fa-user ${styles.xl1}`}></i>
									</div>
									<div className={styles.guestii_names}>
										<p className={styles.m2}>{teamInvite.first_name} {teamInvite.last_name}</p>
										<p className={`${styles.s3} ${styles.emailInvite}`}>{teamInvite.email}</p>
									</div>
								</div>

								<button className={styles.guestii_edit_btn} onClick={() => handleOpen("edit", teamInvite)}>
									<i class={`fa-solid fa-pen ${styles.m1}`}></i>
								</button>

								<button className={styles.guestii_trash_btn} onClick={() => handleDelete(teamInvite)}>
									<i class={`fa-solid fa-trash-can ${styles.m1}`}></i>
								</button>


									{!collapseFilters &&
								      <div className={styles.statsGrid}>
								        {stats.map((stat, index) => (
								          	<div key={index} className={styles.statBox}>
								            	<span className={styles.statIcon}>{stat.icon}</span>
								            	<div className={styles.statText}>
								              		<p className={styles.statLabel}>{stat.label}</p>
								              		<span className={styles.statValue}>{stat.value}</span>
								            	</div>
								          	</div>
								        ))}
								      </div>
							      	}
							</div>
						:
							<div className={styles.preModule}>
								<i className={`fa-solid fa-user ${styles.xl1}`}></i>
								<p className={`${styles.s1}`}>Click on a Team Member to view their profile and statistics</p>
							</div>
					}
				</>
			}
		</div>
	)
}

const TeamPage = ({ handleOpen, teamInvite, setTeamInvite, teamInviteOG, setTeamInviteOG }) => {
	const [collapseFilters, setCollapseFilters] = useState(true)
	const [showUpdateInvites, setShowUpdateInvites] = useState(false)
	const current = "Team"
	
	return (
		<div className={`${styles.container_outer} ${styles.fadeContainer}`}>
			<div className={styles.container}>
				<Sidebar { ... { current } }/>

				<div className={styles.content_container}>
					<Banner { ... { handleOpen } }/>

					<div className={styles.hub_layout}>
						<TableDisplay {... { handleOpen, setTeamInvite, teamInvite, setTeamInviteOG, setShowUpdateInvites } }/>

						<div className={styles.hub_secondary_layout}>
							<TeamInfoWidget { ... { setTeamInvite, teamInvite, collapseFilters, handleOpen } }/>
							<ToggleBar { ... { collapseFilters, setCollapseFilters } }/>
							<QuickInviteWidget { ... { setTeamInvite, teamInvite, collapseFilters, teamInviteOG, setShowUpdateInvites, showUpdateInvites } }/>
						</div>
					</div>
					

					
				</div>
			</div>
		</div>
	)
}

const QuickInviteWidget = ({ setTeamInvite, teamInvite, collapseFilters, teamInviteOG, setShowUpdateInvites, showUpdateInvites }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [allEvents, setAllEvents] = useState([])


	useEffect(() => {
		const handleLoad = async () => {
			setIsLoading(true)


			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			// try {
			// 	const retrieve = await axios.get(`/api/guestiis/get-all-guestiis/${userId}/${expiry}`);
			// 	setAllEvents(retrieve.data.allEvents)
			// } catch (e) {
			// 	console.log(e)
			// 	localStorage.removeItem("_id")
			// 	localStorage.removeItem("expiry")
			// 	window.location = "/connect"
			// }


			setIsLoading(false)
		}

		handleLoad()
	}, []);

	const handleForm = () => {

	}

	const mappedMatches = (checking, against) => {
		let doesContain = checking.length === against.length;

		checking.forEach((check) => {
			if (!(against.includes(check))) {
				doesContain = false
			}
		})

		return doesContain
	}

	const checkInvite = async (event) => {
		let teamDup = { ...teamInvite }
		let teamDupOG = { ...teamInviteOG }

		let eventsDup = [ ...teamDup['events'] ]
		let eventsDupOG = [ ...teamDupOG['events'] ]

		if (eventsDup.filter(e => e._id === event._id).length > 0) {
			let eventsFiltered = eventsDup.filter(e => e._id !== event._id)
			teamDup['events'] = eventsFiltered
		} else {
			eventsDup.push(event)
			teamDup['events'] = eventsDup
		}

		let newEventsMapped = teamDup.events.map(event => event.name)
		let ogEventsMapped = teamDupOG.events.map(eventOG => eventOG.name)

		if (mappedMatches(newEventsMapped, ogEventsMapped)) {
			setShowUpdateInvites(false)
		} else {
			setShowUpdateInvites(true)
		}

		setTeamInvite(teamDup)
	}


	const submitNewInvites = async () => {
    	const response = await axios.post(`/api/team/update-invites`, {
      		events: teamInvite.events,
      		teamMember: teamInvite._id,
    	});

    	window.location.reload()
	}

	const searchControl = (event) => {
	    let input = event.target.value;
	    let filter = input.toUpperCase();
	    let target_div = document.getElementById('guestiisGrid').children

	    for (let i = 0; i < target_div.length; i++) {
	    	let showItem = false
	        let mainValue = target_div[i].getElementsByTagName("p")[0].textContent

            if (mainValue.toUpperCase().indexOf(filter) > -1) {
                showItem = true;
            }

	        if (showItem) {
	            target_div[i].style.display = "flex";
	        } else {
	            target_div[i].style.display = "none";
	        }
	    }
	};

	return (
		<div className={`${styles.widget_container} ${styles.quickInviteContainer} ${!collapseFilters && styles.quickInviteModule} ${teamInvite && styles.widget_container_extra}`}>
			<div className={styles.widget_banner}>
				<p>Quick Invite</p>
			</div>

			{/* {teamInvite && */}
			{/* 	<MovingTextContainer */}
			{/* 		label={"Search events..."} */}
			{/* 		icon={"fa-solid fa-magnifying-glass"} */}
			{/* 		handleForm={null} */}
			{/* 		formData={{}} */}
			{/* 		dashboard={true} */}
			{/* 	/> */}
			{/* } */}


			{isLoading
				? <p>Loading...</p>
				:
					<>
						{!teamInvite
							?
								<div className={styles.preModule}>
									<i className={`fa-solid fa-plus ${styles.xl1}`}></i>
									<p className={`${styles.s1}`}>Click on a team member to quick invite them to an event</p>
								</div>

							:
								<>
									{teamInvite.role.name === "SuperAdmin"
										? <div className={styles.preModule}><p>This user can see all events!</p></div>
										:
										<>
								      		{allEvents.length > 0
								      			?
								      				<div id="guestiisGrid" className={styles.guestiisGrid} style={{ gridTemplateRows: `repeat(${Math.ceil(allEvents.length / 2)}, max-content)` }}>
								      					{allEvents.map((event_na, index) => {
								      						let isLast = index === allEvents.length - 1
								      						let teamFiltered = (teamInvite && teamInvite.events) ? teamInvite.events.filter(event => event.name === event_na.name) : []
								      						
								      						return (

																<button disabled={true} className={`${styles.quickInvite_member} ${(teamFiltered.length > 0) && styles.activeGuestiiInvite}`} onClick={() => checkInvite(event_na)}>
																	<p className={styles.s1}>{event_na.name}</p>
																</button>
								      						)
								      					})}
									              	</div>
								      			: <div className={styles.preModule}><p>No events...</p></div>
						      				}
						      			</>
				      				}

				      				{showUpdateInvites &&
				      					<button className={styles.quickInviteSubmit} onClick={() => submitNewInvites()}><p className={styles.s2}>Update</p></button>
				      				}
								</>
						}
					</>
			}


		</div>
	)
}

const ToggleBar = ({ collapseFilters, setCollapseFilters }) => {
	const [collapseDeg, setCollapseDeg] = useState(0)
	

    const handleCollapse = async (control) => {
    	let intervalId;

        switch (control) {
            case 'enter':
            	if (collapseDeg !== 0) {
            		setCollapseDeg(0)
            	}

            	if (collapseDeg !== 15) {
	                intervalId = setInterval(() => {
	                    setCollapseDeg(prevDeg => {
	                        if (prevDeg >= 15) {
	                            clearInterval(intervalId);
	                            return prevDeg;
	                        }
	                        return prevDeg + 1;
	                    });
	                }, 10);
            	}
                break;
            case 'leave':
                intervalId = setInterval(() => {
                    setCollapseDeg(prevDeg => {
                        if (prevDeg === 0) {
                            clearInterval(intervalId);
                            return prevDeg;
                        }
                        return prevDeg - 1;
                    });
                }, 10);
                break;
             case 'toggle':
             	setCollapseDeg(0)
             	setCollapseFilters(!collapseFilters)
             	break;
        }
    };


	return (
		<div className={styles.toggle_bar_container}>
			<div 
				className={`${styles.collapseInner} ${collapseDeg === 0 && styles.collapseOpacitated}`}
				onMouseEnter={() => handleCollapse('enter')}
				onMouseLeave={() => handleCollapse('leave')}
				onClick={() => handleCollapse('toggle')}
			>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(0.15rem) rotate(${collapseFilters ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(-0.15rem) rotate(${(!collapseFilters && collapseDeg !== 0) ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        </div>
		</div>

	)
}

const Team = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(true);
	const [tempFormData, setTempFormData] = useState(null)
	const [isOpen, setIsOpen] = useState(null)
	const [teamInvite, setTeamInvite] = useState(null)
	const [teamInviteOG, setTeamInviteOG] = useState(null)


	useEffect(() => {
		const checkForNavigate = () => {
			const fromState = JSON.parse(sessionStorage.getItem('navigationState'));

			if (fromState) {
				setTeamInvite(fromState.from)
				setTeamInviteOG(fromState.from)
				sessionStorage.removeItem('navigationState');
			}
		}

		checkForNavigate()
	}, []);

	function handleOpen(target, teamMember?) {
		switch (target) {
			case 'edit':
				setIsOpen("new")
				setTempFormData(teamMember)
				break;
			case 'close':
				setIsOpen(null)
				setTempFormData(null)
				break;
			default:
				setIsOpen(target)
		}
	}

	return (
		<div className={`${styles.overlay} ${(isOpen && isOpen === "new") && styles.white_overlay}`}>
			<div className={`${(isOpen && isOpen === "new") && styles.hidden_container} ${styles.fadeContainer}`}>
				<TeamPage {... { handleOpen, teamInvite, setTeamInvite, teamInviteOG, setTeamInviteOG } }/>
			</div>

 			{isOpen === "new" &&
				<NewTeamMember { ... { tempFormData, handleOpen } }/>
			}
		</div>
// 		<div className={`${styles.overlay} ${(isOpen && isOpen === "new") && styles.white_overlay}`}>
// 			<div className={`${(isOpen && isOpen === "new") && styles.hidden_container} ${styles.fadeContainer}`}>
// 				<TeamPage {... { handleOpen, teamInvite, setTeamInvite, teamInviteOG, setTeamInviteOG } }/>
// 			</div>
// 
// 			{isOpen === "new" &&
// 				<NewTeamMember { ... { tempFormData, handleOpen } }/>
// 			}
// 		</div>
	);
};

export default Team;